/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

import {ContactId, ContactInput} from "../__ignore/schemas";

/**
 * @summary Edit lead contact
 */
export const EditLeadContactBody = ContactInput;

export const EditLeadContactResponse = zod.void();

/**
 * @summary Remove lead contact
 */
export const RemoveLeadContactResponse = zod.void();

/**
 * @summary Add lead contact
 */
export const AddLeadContactBody = ContactInput;

export const AddLeadContactResponse = ContactId;
